import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.shipment
 * @constructor
 */
export class ShipmentCapabilityModel extends BaseModel {
  /**
   * @param {string} carrier
   * @param {string} service
   * @param {string} size
   * @param {string} fromCountryCode
   * @param {string} toCountryCode
   * @param {string} type
   * @param {number} price
   * @param {string[]} serviceOptions
   */
  constructor({
    carrier,
    service,
    size,
    fromCountryCode,
    toCountryCode,
    type,
    price,
    serviceOptions,
  }) {
    super()

    /** @type {string} */
    this.carrier = carrier

    /** @type {string} */
    this.service = service

    /** @type {string} */
    this.size = size

    /** @type {string} */
    this.fromCountryCode = fromCountryCode

    /** @type {string} */
    this.toCountryCode = toCountryCode

    /** @type {string} */
    this.type = type

    /** @type {number} */
    this.price = price

    /** @type {string[]} */
    this.serviceOptions = serviceOptions
  }
}

export const SHIPMENT_CAPABILITY = {
  DOOR: 'DOOR',
}
